type VenuePlaceholderImageProps = {
  className?: string;
};

const VenuePlaceholderImage = ({
  className = "w-[104px] h-[104px] rounded-lg",
}: VenuePlaceholderImageProps) => {
  return (
    <div className={`relative overflow-hidden flex-shrink-0 ${className}`}>
      {/* Background checkerboard layer */}
      <div
        className="absolute inset-0 w-full h-full"
        style={{
          backgroundImage:
            "url(/images/No_Data_Placeholder_Images_Background.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      {/* Foreground Sociability icon */}
      <img
        src="/images/No_Data_Placeholder_Images_Foreground.png"
        alt=""
        aria-hidden="true"
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-1/2 h-1/2 object-contain z-10"
      />
    </div>
  );
};

export default VenuePlaceholderImage;
